import React, { useEffect, useState } from "react"
import { useDispatch } from 'react-redux'
import ModalComponent from "../../components/Modal/Modal"
import { showSnackBar } from "../../components/Snackbar/Snackbar"
import { useMyContextLoading } from "../../components/LoadingContextProvider/LoadingContextProvider"
import { updateNoteById } from "../../features/notes/notes"
import NotesArea, { extractMentions } from "../../components/NotesArea/NotesArea"

const EditNotesModal = ({ triggerUpdate, dataRow, customOpenModal, onClose }) => {
  const dispatch = useDispatch()
  const { triggerLoading } = useMyContextLoading()
  const [showModal, setShowModal] = useState(false)

  const handleSaveNote = async (noteText) => {
    triggerLoading(true)
    const mentions = extractMentions(noteText)
    try {
      const response = await dispatch(updateNoteById({
        noteId: dataRow?._id,
        text: noteText,
        mentions
      }))

      if (!response.error) {
        showSnackBar("success", "Note updated successfully")
        triggerUpdate(true)
        setShowModal(false)
        if (onClose) onClose()
      } else {
        showSnackBar("error", response.payload || "Error updating note")
      }
    } catch (error) {
      showSnackBar("error", error.message || "An unexpected error occurred while updating the note")
    } finally {
      triggerLoading(false)
    }
  }

  useEffect(() => {
    if (customOpenModal !== undefined) {
      setShowModal(customOpenModal)
    }
  }, [customOpenModal])

  return (
    <ModalComponent
      title="Edit Note"
      buttonClasses="border !border-primary-main h-10"
      buttonType="outlined"
      disableBtn={false}
      customOpenModal={showModal}
      modalButtonTitle="Update"
      onClose={() => {
        setShowModal(false)
        if (onClose) onClose()
      }}
      hideDefaultButtons={true}
      isMentions={true}
      modalClasses="max-w-[700px] w-full"
    >
      <div className="flex flex-col justify-center items-end w-full max-w-[700px] mx-auto overflow-visible">
        <NotesArea
          userId={dataRow?.user?._id || dataRow?.user}
          isEditMode={true}
          initialNoteText={dataRow?.text || ''}
          initialMentions={dataRow?.mentions || []}
          saveButtonText="Update Note"
          onSave={handleSaveNote}
        />
      </div>
    </ModalComponent>
  )
}

export default EditNotesModal